/*

Suresh Peddavoora 10/26/2022 3075154998  Added Class Name for Table Enhancements
Ashraf 10/30/2022 3075154998 fixed table pagination issue
saikrishna 11/03/2022 3075154998 changed the paginationOptions
Dilip 11/03/2022 3075154998 Added record code in delete popup
Raghu 11/30/2022 3075154998 Table footer styling fixes
*/
import React, {createRef, useState} from 'react';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../../../../components/TableIcons';
import DeleteTableRecordPopup from '../../../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import {TablePagination} from '@material-ui/core';
import {defaultRows} from '../../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../../constants/ReusableConstants';

export default function ConditionTable({
  conditionData,
  setConditionData,
  setIsConditionEditMode,
  setConditionRowData,
  setConditionCode,
}) {
  const [rows, setRows] = useState(defaultRows);
  const columns = [
    // {
    //   title: "Code",
    //   field: "code",
    //   cellStyle: { maxWidth: 500 },
    //   minWidth: "300px",
    // },
    {
      title: 'Seq No',
      field: 'seqNo',
      // headerStyle: {
      //   textAlign: "center",
      // },
      // cellStyle: {
      //   maxWidth: 100,
      //   textAlign: "center",
      // },
      render: (rowData) => {
        const rowSeqNo = rowData?.tableData?.id ?
          rowData?.tableData?.id + 1 :
          rowData?.tableData?.id === 0 ?
            1 :
            '';
        conditionData[rowData?.tableData?.id].seqNo = rowSeqNo;
        return rowSeqNo;
      },
    },
    {
      title: 'Report Name',
      field: 'recordCode',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
      render: (rowData) => {
        return rowData?.recordCode?.recordCode + '-' + rowData?.recordCode?.description;
      },
    },
    {
      title: 'Record Type',
      field: 'recordType',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
      render: (rowData) => {
        return rowData?.recordType?.value;
      },
    },
    {
      title: 'Description',
      field: 'description',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        maxWidth: 200,
      },
    },
  ];

  const tableRef = createRef();
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const tableDataCondition = conditionData ?
    conditionData?.map((item, i) => ({
      ...item,
      id: i,
    })) :
    [];

  const handleConditionEdit = (rowData) => {
    setIsConditionEditMode(true);
    setConditionRowData(rowData);
  };
  const handleDelete = (rowData) => {
    setIsDelete(true);
    setDeleteData(rowData);
  };
  const handleClose = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    setTimeout(() => {
      const data = [...conditionData];
      const newData = data.filter(
        (row, i) =>
          row.seqNo !== deleteData.seqNo,
        // row.toField !== deleteData.toField ||
        // row.srcField !== deleteData.srcField ||
        // row?.operator?.id !== deleteData?.operator?.id ||
        // row.dateFormat !== deleteData.dateFormat
      );
      setConditionData(newData);
    }, 1000);
    setIsDelete(false);
  };
  return (
    <div>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Condition"
        value={`Are you sure you want to delete this  ${deleteData?.recordCode?.recordCode} condition?`}
        handleSubmit={handleSubmit}
      />
      <div className="custom-table global-field-table">
        <GuiTable
          title=""
          columns={columns}
          icons={tableIcons}
          tableRef={tableRef}
          data={tableDataCondition}
          options={{
            search: false,
            toolbar: false,
            pageSize: rows,
            showSelectAllCheckbox: false,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          components={{
            Pagination: (props) => (
              <div className="global-field-table-footer">
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              </div>
            )}}
          actions={[
            {
              icon: 'edit',
              tooltip: 'Edit',
              onClick: (event, rowData) => {
                handleConditionEdit(rowData);
                setConditionCode(rowData.id);
              },
            },
            {
              icon: 'delete',
              tooltip: 'Delete',
              onClick: (event, rowData) => {
                handleDelete(rowData);
                setIsDelete(true);
              },
            },
          ]}
        />
      </div>
    </div>
  );
}
